import LevelData from 'src/replicant/airtable/LevelData';
import { tuple } from 'src/replicant/utils/types';

function levelUpReward(fromLevel: number, toLevel: number) {
  let sum = 0;

  for (let i = fromLevel; i < toLevel; i++) {
    sum += LevelData[i + 1].reward_points;
  }
  return sum;
}

function requiredXp(currentLevel: number) {
  return LevelData[currentLevel + 1].xp;
}

function milestoneXp(milestone: Milestone, petStage: MilestoneEvolution) {
  const milestoneXpTable: Record<
    Milestone,
    Record<MilestoneEvolution, number> | number
  > = {
    evolution: {
      baby: 0,
      kid: 10,
      youth: 20,
      adult: 40,
    },
    death: {
      baby: 5,
      kid: 10,
      youth: 20,
      adult: 40,
    },
    debut: 80,
  };

  return (
    milestoneXpTable[milestone][petStage] ?? milestoneXpTable[milestone] ?? 0
  );
}

function toDisplay(level: number) {
  return LevelData[level].level;
}

export const levelRuleset = {
  requiredXp,
  levelUpReward,
  milestoneXp,
  toDisplay,
};

export const milestoneEvolutions = tuple('baby', 'kid', 'youth', 'adult');
export type MilestoneEvolution = typeof milestoneEvolutions[number];
export const milestones = tuple('evolution', 'debut', 'death');
export type Milestone = typeof milestones[number];
